import React from 'react'
import {gql} from '@apollo/client'
import PropTypes from 'prop-types'
import {Mutation} from '@apollo/client/react/components'

export const USER_EVENT_QUERY = gql`
  mutation userEvent($versionUuid: String!, $eventType: EventType, $meta: [InputMeta]) {
    userEvent(versionUuid: $versionUuid, eventType: $eventType, meta: $meta) {
      id
      versionUuid
      userUuid
      ip
      eventType
      meta {
        key
        value
      }
    }
  }
`

const handlerFactory = (children, id) => onEvent => {
    const onEventHandler = (eventType, meta = {}) => {
      const metaData = []

      for (const [key, value] of Object.entries(meta)) {
        metaData.push({key, value})
      }

      return onEvent({variables: {versionUuid: id, eventType, meta: metaData}})
    }

    return children(onEventHandler)
  },
  UserEventMutation = ({children, id}) => <Mutation mutation={USER_EVENT_QUERY}>{handlerFactory(children, id)}</Mutation>

UserEventMutation.propTypes = {children: PropTypes.func.isRequired, id: PropTypes.string.isRequired}

export default UserEventMutation
